module.exports = __webpack_public_path__ + "static/media/BANNER-FOOD-SAFETY.1151d03a.png";